import React from 'react'
import { Outlet } from 'react-router-dom'

const AuthPages = () => {
  return (
   <Outlet/>
  )
}

export default AuthPages